import { userDate } from 'owa-datetime/lib/userDate';
import { getTimeGroupHeader, NudgedGroupHeaderId, TimeGroupHeader } from 'owa-mail-group-headers';
import { shouldTableSortByRenewTime } from 'owa-mail-list-response-processor';
import { MailRowDataPropertyGetter, TableView } from 'owa-mail-list-store';
import { isUnpinnedNudgedRow } from 'owa-mail-nudge-store';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

/**
 * Get TimeGroupHeader for item
 * @param rowKey item key for which we want to lookup time group range
 * @param tableView tableView
 * @return group header for this row
 */
export default function getGroupHeaderForSortByDateTime(
    rowKey: string,
    tableView: TableView
): TimeGroupHeader {
    if (isUnpinnedNudgedRow(rowKey, tableView)) {
        // nudged rows do not stay in date time sort order
        // return now instead of looking up the time header
        return {
            headerText: () => '',
            headerId: NudgedGroupHeaderId.Nudged,
            rangeStartTime: null,
            rangeEndTime: null,
        };
    } else {
        let propertyGetter: (rowKey: string, tableView: TableView) => string;
        if (shouldTableSortByRenewTime(tableView.tableQuery)) {
            propertyGetter = MailRowDataPropertyGetter.getLastDeliveryOrRenewTimeStamp;
        } else if (folderNameToId('drafts') == tableView.tableQuery.folderId) {
            propertyGetter = MailRowDataPropertyGetter.getLastModifiedTimeStamp;
        } else {
            propertyGetter = MailRowDataPropertyGetter.getLastDeliveryTimeStamp;
        }

        const timeStamp = propertyGetter(rowKey, tableView);
        const date = userDate(timeStamp);

        return getTimeGroupHeader(date);
    }
}
